import { useState } from 'react';
import { X, ExternalLink, Zap, TrendingUp, Radio } from 'lucide-react';
import { Button } from '@/components/ui/button';
import aiPulseLogo from '@/assets/ai-pulse-logo.png';

export function AIPulseBanner() {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[hsl(195,100%,30%)] via-[hsl(190,100%,40%)] to-[hsl(200,100%,35%)]">
      {/* Animated background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-cyan-200 rounded-full blur-3xl animate-pulse delay-700" />
      </div>

      <div className="container mx-auto px-4 py-5 relative">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 flex-1 min-w-0">
            {/* Logo */}
            <a
              href="https://aipulseplatform.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0"
            >
              <img
                src={aiPulseLogo}
                alt="AI Pulse"
                className="w-14 h-14 rounded-xl shadow-lg ring-2 ring-white/20"
              />
            </a>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-cyan-100 bg-white/15 px-2 py-0.5 rounded-full backdrop-blur-sm">
                  <Radio className="h-3 w-3 animate-pulse" />
                  LIVE
                </span>
                <span className="text-xs text-white/70 hidden sm:inline">Partner Spotlight</span>
              </div>
              <h3 className="text-white font-bold text-lg leading-tight">
                AI Pulse — Real-Time AI Intelligence Feed
              </h3>
              <p className="text-white/80 text-sm mt-0.5 hidden sm:block">
                Track breaking AI signals, emerging trends, and market momentum scores in real time.
              </p>
            </div>
          </div>

          {/* Feature pills - hidden on mobile */}
          <div className="hidden lg:flex items-center gap-2 flex-shrink-0">
            <span className="inline-flex items-center gap-1 text-xs text-white/90 bg-white/10 px-3 py-1.5 rounded-full backdrop-blur-sm">
              <Zap className="h-3.5 w-3.5 text-yellow-300" />
              Breaking Signals
            </span>
            <span className="inline-flex items-center gap-1 text-xs text-white/90 bg-white/10 px-3 py-1.5 rounded-full backdrop-blur-sm">
              <TrendingUp className="h-3.5 w-3.5 text-green-300" />
              Momentum Tracking
            </span>
          </div>

          {/* CTA */}
          <a
            href="https://aipulseplatform.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 inline-flex items-center gap-1.5 bg-white text-[hsl(195,100%,30%)] px-5 py-2.5 rounded-full text-sm font-bold hover:bg-white/90 transition-all hover:scale-105 shadow-lg"
          >
            Explore AI Pulse
            <ExternalLink className="h-3.5 w-3.5" />
          </a>

          {/* Dismiss */}
          <Button
            variant="ghost"
            size="icon"
            className="text-white/60 hover:text-white hover:bg-white/10 h-8 w-8 flex-shrink-0"
            onClick={() => setIsDismissed(true)}
            aria-label="Dismiss banner"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
